import { Subscription, UserType } from 'lib.store/src/models-to-replace/auth';
import { PostSubscriptionResponse } from 'lib.store/src/main/subscription/models';
import { Dispatch } from 'redux';

type SubscriptionResponse = {
  data: PostSubscriptionResponse;
};

export const updateUserSubscriptionInStore = (
  dispatch: Dispatch,
  response: SubscriptionResponse,
  currentUser?: UserType,
) => {
  const subscription: Subscription = {
    id: response.data.data.id,
    status: response.data.data.status,
    type: response.data.data.type,
    options: response.data.data.options,
    date: response.data.data.date,
    is_active: response.data.data.is_active,
    money: response.data.data.money || {
      spend: 0,
      limit: 0,
      price_annual: 0,
      price_per_credit: 0,
      discount_annual: 0,
      credits: 0,
    },
  };
  const existingSubscriptions = currentUser?.organization?.subscriptions || [];
  // one PRO per organization: a renewal returns the same row, which replaces the old copy
  const updatedSubscriptions = [
    ...existingSubscriptions.filter(({ id }) => id !== subscription.id),
    subscription,
  ];

  dispatch({
    type: 'user/patchUserState',
    payload: {
      organization: {
        ...currentUser?.organization,
        subscriptions: updatedSubscriptions,
        // the order and the top-up read this flag, not the list
        has_pro_access: currentUser?.organization?.has_pro_access || subscription.is_active,
      },
    },
  });
};

export const updateUserBalanceInStore = (
  dispatch: Dispatch,
  topUpAmount: number,
  currentUser?: UserType,
) => {
  const currentBalance = currentUser?.organization?.billing?.balance || 0;
  const newBalance = currentBalance + topUpAmount;

  dispatch({
    type: 'user/patchUserState',
    payload: {
      organization: {
        ...currentUser?.organization,
        billing: {
          ...currentUser?.organization?.billing,
          balance: newBalance,
        },
      },
    },
  });
};

export const updateUserTopUpStatusInStore = (
  dispatch: Dispatch,
  response: {
    data: {
      organization: {
        billing: { top_up_status: { id: number; name: string; translate: string } };
        subscriptions: unknown[];
      };
    };
  },
  currentUser?: UserType,
) => {
  const organization = response.data.organization;
  const top_up_status = organization.billing.top_up_status;
  const subscriptions = organization.subscriptions;

  dispatch({
    type: 'user/patchUserState',
    payload: {
      organization: {
        ...currentUser?.organization,
        billing: {
          ...currentUser?.organization?.billing,
          top_up_status,
        },
        subscriptions,
      },
    },
  });
};
